import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { GeneralHttpService } from '../general-http.service';
import { LoginRequest } from '../models/requests/login-request-model';
import {
  AccessTokenResCustomerInfo,
  LoginResponse,
} from '../models/responses/login-response-model';
import { SessionStorageService } from '../storage/session-storage.service';
import { StorageKey } from '../storage/storage-model';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from '../storage/local-storage.service';
import { CustomerChangeRequest } from '../models/requests/customer-change-model';
import { ChangePasswordRequest } from '../models/requests/password-change-model';
import { AuthInfoResponse } from '../models/responses/autInfo-response-model';
import { RefreshTokenRequest } from '../models/requests/refreshToken-model';
// tslint:disable-next-line: max-line-length
const {
  AUTH_TOKEN,
  USER_NAME,
  COMPANIES_INFO,
  REFRESH_TOKEN,
  SELECTED_CUSTOMER_IDENTITY,
  SELECTED_CUSTOMER_TITLE,
  USER_EMAIL,
  AVAILABLE_SERVICES,
  RIGHT_INFOS,
} = StorageKey;
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = environment.authApiUrl;
  token: string;
  redirectUrl: string;
  private loggedIn: BehaviorSubject<boolean>;
  constructor(
    private generalHttpService: GeneralHttpService,
    private storageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {
    this.token = this.storageService.read(AUTH_TOKEN) || '';
    this.loggedIn = new BehaviorSubject<boolean>(false);
    console.log(this.loggedIn);
  }

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  login(
    email,
    password,
    captchaCode?,
    twoFactorCode?,
    customerIdendity?
  ): Observable<LoginResponse> {
    const request: LoginRequest = new LoginRequest();
    (request.Email = email),
      (request.Password = password),
      (request.CaptchaCode = captchaCode),
      (request.TwoFactorCode = twoFactorCode),
      (request.CustomerIdentity = customerIdendity),
      (request.ClientType = 'AdminPortal');
    console.log(request);
    const result = this.generalHttpService.post<LoginResponse>(
      this.baseUrl + '/Auth/AccessToken',
      request
    );
    console.log(result);
    return result;
  }

  authInfo(): Promise<AuthInfoResponse> {
    return this.generalHttpService
      .post<AuthInfoResponse>(this.baseUrl + '/Auth/AuthInfo')
      .toPromise();
  }

  //ORGINAL HALI
  // authInfo(): Observable<AuthInfoResponse> {
  //   return this.generalHttpService.post<AuthInfoResponse>(this.baseUrl + '/Auth/AuthInfo');
  // }

  refreshToken(accessToken, refreshToken): Observable<LoginResponse> {
    const request: RefreshTokenRequest = new RefreshTokenRequest();
    (request.accessToken = accessToken), (request.refreshToken = refreshToken);
    return this.generalHttpService.post<LoginResponse>(
      this.baseUrl + '/Auth/RefreshToken',
      request
    );
  }

  changeCustomer(accessToken, customerIdendity): Observable<LoginResponse> {
    const request: CustomerChangeRequest = new CustomerChangeRequest();
    (request.accessToken = accessToken),
      (request.customerIdentity = customerIdendity);
    return this.generalHttpService.post<LoginResponse>(
      this.baseUrl + '/Auth/ChangeCustomer',
      request
    );
  }

  SendPasswordResetEMail(email, captchaCode): Observable<LoginResponse> {
    const request: LoginRequest = new LoginRequest();
    (request.Email = email),
      (request.CaptchaCode = captchaCode),
      (request.ClientType = 'AdminPortal');
    return this.generalHttpService.post<LoginResponse>(
      this.baseUrl + '/Auth/SendPasswordResetEMail',
      request
    );
  }

  changePassword(
    oldPassword?,
    newPassword?,
    captchaCode?,
    email?,
    resetKey?
  ): Observable<LoginResponse> {
    const request: ChangePasswordRequest = new ChangePasswordRequest();
    // tslint:disable-next-line: max-line-length
    (request.captchaCode = captchaCode),
      (request.oldPassword = oldPassword),
      (request.newPassword = newPassword),
      (request.eMail = email),
      (request.resetPasswordKey = resetKey),
      (request.clientType = 'AdminPortal');
    return this.generalHttpService.post<LoginResponse>(
      this.baseUrl + '/Auth/ChangePassword',
      request
    );
  }

  getCaptchaSiteKey(): Observable<string> {
    return this.generalHttpService.post<string>(
      this.baseUrl + '/Auth/CaptchaSiteKey'
    );
  }
  // tslint:disable-next-line: typedef
  logoutWithRedirect(redirectTo: string) {
    this.storageService.remove(AUTH_TOKEN);
    this.loggedIn.next(false);
    return this.router.navigateByUrl(redirectTo, { replaceUrl: true });
  }

  logout() {
    this.token = '';
    // this.storageService.remove(AUTH_TOKEN);
    this.storageService.clear();
    this.loggedIn.next(false);
    this.router.navigate(['/login']);
  }
  // tslint:disable-next-line: typedef
  async initialise(
    info: LoginResponse,
    user_email?,
    redirectTo?,
    selectedCustomerIdentity?,
    selectedCustomerTitle?
  ) {
    this.loggedIn.next(true);
    user_email =
      user_email != null
        ? user_email
        : this.localStorageService.read(USER_EMAIL);
    selectedCustomerTitle =
      selectedCustomerTitle != null
        ? selectedCustomerTitle
        : this.storageService.read(SELECTED_CUSTOMER_TITLE);
    this.storageService.save(AUTH_TOKEN, info.accessToken);
    this.storageService.save(
      USER_NAME,
      info.userInfo.name + ' ' + info.userInfo.surname
    );
    this.storageService.save(COMPANIES_INFO, info.partners);
    this.storageService.save(REFRESH_TOKEN, info.refreshToken);
    this.localStorageService.save(USER_EMAIL, user_email);
    // if (selectedCustomerIdentity != null) {
    // this.localStorageService.save(SELECTED_CUSTOMER_IDENTITY, selectedCustomerIdentity);
    // this.localStorageService.save(SELECTED_CUSTOMER_TITLE, selectedCustomerTitle);
    if (
      selectedCustomerIdentity === null ||
      selectedCustomerIdentity === undefined
    ) {
      this.storageService.save(
        SELECTED_CUSTOMER_IDENTITY,
        info.partners[0].identity
      );
      this.storageService.save(SELECTED_CUSTOMER_TITLE, info.partners[0].title);
    } else {
      this.storageService.save(
        SELECTED_CUSTOMER_IDENTITY,
        selectedCustomerIdentity
      );
      this.storageService.save(SELECTED_CUSTOMER_TITLE, selectedCustomerTitle);
    }

    await this.authInfo().then((response) => {
      if (response) {
        // this.storageService.save(AVAILABLE_SERVICES, response.avaiableServices);
        const result = this.storageService.save(
          RIGHT_INFOS,
          response.rightInfos
        );
        if (result) {
          // return this.router.navigateByUrl(redirectTo);
        }
      }
    });
    return this.router.navigateByUrl(redirectTo);

    //kullanıcı bılgılerı ve yetkılerını almak ıcın (ORJINAL KULLANILAN YER BURASIYDI)
    // this.authInfo().subscribe(response => {
    //
    //   this.storageService.save(AVAILABLE_SERVICES, response.avaiableServices);
    //   this.storageService.save(RIGHT_INFOS, response.rightInfos);
    //   return this.router.navigateByUrl(redirectTo);
    // });

    // Burası syncron olarak tasarlandı.Apıler gerı geldıgınde deneme yapılacak
    // this.authInfo().toPromise().then(response => {
    //   this.storageService.syncronSave(AVAILABLE_SERVICES, response.avaiableServices).then(
    //     this.storageService.syncronSave(RIGHT_INFOS, response.rightInfos).then(() => {
    //       return this.router.navigateByUrl(redirectTo);
    //     })
    //   );
    // }).catch(err => {
    //   console.log(err)
    // })

    // }
    // return this.router.navigateByUrl(redirectTo);
  }

  public getToken(): string {
    return this.storageService.read(AUTH_TOKEN);
  }

  public getRefreshToken(): string {
    return this.storageService.read(REFRESH_TOKEN);
  }

  public getUserName(): string {
    return this.storageService.read(USER_NAME);
  }

  public getCompanyInfo(): AccessTokenResCustomerInfo[] {
    return this.storageService.read(COMPANIES_INFO);
  }

  public getSelectedCompanyIdentity(): string {
    return this.storageService.read(SELECTED_CUSTOMER_IDENTITY);
  }

  public getSelectedCompanyIdentityLocalStorage(): string {
    return this.localStorageService.read(SELECTED_CUSTOMER_IDENTITY);
  }

  public getSelectedCompanyTitleLocalStorage(): string {
    return this.localStorageService.read(SELECTED_CUSTOMER_TITLE);
  }

  public getUserEmail(): string {
    return this.localStorageService.read(USER_EMAIL);
  }

  public getSelectedCompanyTitle(): AccessTokenResCustomerInfo {
    return this.storageService.read(SELECTED_CUSTOMER_TITLE);
  }

  public isLogged(): boolean {
    return this.token.length > 0;
  }

  end() {
    this.storageService.clear();
  }
}
